import type { NoteView } from '@shared/types'

export function noteIdFromPath(pathname: string): string | null {
  return /^\/notes\/([^/]+)\/?$/.exec(pathname)?.[1] ?? null
}

export function noteViewFromPath(pathname: string): NoteView {
  if (pathname === '/shared') return 'shared'
  if (pathname === '/archive') return 'archive'
  if (pathname === '/trash') return 'trash'
  const labelId = /^\/labels\/([^/]+)\/?$/.exec(pathname)?.[1]
  return labelId ? `label:${labelId}` : 'all'
}
